import { Injectable } from "@angular/core";
import { ApiService } from "app/shared/apis/api.service";

interface IMedicRequest {
    crm: number;
    uf: string;
    cpf?: string;
}

interface IMedicResponse {
    crm: number;
    dataAtualizacao: string;
    especialidade: string;
    situacao: string;
    tipoInscricao: string;
    uf: string;
}

export interface IMedicConsultResponse {
    crm: string;
    nome: string;
    dataAtualizacao: string;
    especialidade: string;
    situacao: string;
    tipoInscricao: string;
    uf: string;
    email: string;
    telefone: string;
}

interface ICreateDoctorRequest {
    crm: number;
    uf: string;
}

@Injectable({
    providedIn: "root",
})
export class CFMService {
    constructor(private api: ApiService) {}
    endpoind = "cfm";

    consult(body: IMedicRequest) {
        return this.api.getSub<IMedicConsultResponse>(this.endpoind + "/consult", body);
    }

    createDoctor(body: ICreateDoctorRequest) {
        return this.api.postSub<any>(this.endpoind + "/create-doctor", body);
    }

    checkDoctorStatus(userId: number) {
        return this.api.postSub<any>(this.endpoind + `/check-doctor-status/${userId}`, {});
    }
}
